(() => {
    const INLINE_HOST_SELECTOR = ".wair-inline-wrapper";
    const MODAL = ".wair-predict-modal";
    const WAIR_SNIPPET = ".predict-placement";
    const WAIR_BTN = ".wair-launch-btn";

    console.log("WAIR FIX: loaded");

    const hosts = document.querySelectorAll(INLINE_HOST_SELECTOR);

    const inlineify = (element) => {
        // Logic from size-guide.js but WITHOUT auto-clicking the button
        const span = element.querySelector("span.wr-inset-0");
        if (span) {
            // span.click(); // DISABLED: This causes auto-open!
            console.log("WAIR FIX: Span found but NOT clicked to prevent auto-open");
        }
        // REMOVED: else if (element instanceof HTMLButtonElement) { element.click(); }

        const host = element.closest(INLINE_HOST_SELECTOR);
        if (host) {
            console.log("WAIR FIX: Moving modal to host", host);
            const modal = document.querySelector(MODAL);
            if (modal) {
                host.appendChild(modal);
            }
            document.body.style.position = "relative";
        }
    };

    // Ensure buttons are visible on load!
    const makeVisible = () => {
        document.querySelectorAll(WAIR_SNIPPET).forEach(el => {
            el.style.display = "block"; // or flex depending on CSS, block is safer to start
            el.style.visibility = "visible";
            el.style.opacity = "1";
        });
    };

    // Initial visibility force
    makeVisible();

    // Listeners for modal events (Syncing visibility)
    window.addEventListener("onPredictModalClose", () => {
        makeVisible();
    });

    window.addEventListener("onPredictModalOpen", () => {
        // Only hide if we are sure? Maybe don't hide it at all for now to be safe.
        // document.querySelectorAll(WAIR_SNIPPET).forEach(el => el.style.display = "none");
        console.log("WAIR FIX: Modal opened");
    });

    const observerCallback = (mutations) => {
        for (const mutation of mutations) {
            for (const node of mutation.addedNodes) {
                if (!(node instanceof HTMLElement)) return;

                const isWairBtn = node.matches(WAIR_BTN) || node.querySelector(WAIR_BTN);
                const isInsidePlacement = node.parentElement && node.parentElement.matches(WAIR_SNIPPET);
                const isPlacement = node.matches(WAIR_SNIPPET);

                if (isWairBtn || isInsidePlacement || isPlacement) {
                    const wrapper = node.closest(WAIR_SNIPPET) || node;
                    // Force visibility on new nodes too
                    wrapper.style.display = "block";

                    if (!wrapper.dataset.wairFixProcessed) {
                        wrapper.dataset.wairFixProcessed = "true";
                        console.log("WAIR FIX: Processing node", node);
                        inlineify(wrapper);
                    }
                }
            }
        }
    };

    // Initial Scan
    document.querySelectorAll(WAIR_SNIPPET).forEach(el => {
        // Force visibility
        el.style.display = "block";

        if (el.querySelector(WAIR_BTN) || el.children.length > 0) {
            if (!el.dataset.wairFixProcessed) {
                el.dataset.wairFixProcessed = "true";
                console.log("WAIR FIX: Initial scan found", el);
                inlineify(el);
            }
        }
    });

    if (hosts.length > 0) {
        hosts.forEach(host => {
            const observer = new MutationObserver(observerCallback);
            observer.observe(host, { childList: true, subtree: true });
        });
    }

})();
